import { IRootConfig } from '@app/core/http';
import { environment } from 'src/environments/environment';

const superHttpClientModuleConfig: IRootConfig = {
  domains: {
    backoffice: {
      url: environment.serverUrl,
      isDefault: true
    }
  }
};

export { superHttpClientModuleConfig };
